import { render } from "./ListeAffectation.vue?vue&type=template&id=4812c906&ts=true"
import script from "./ListeAffectation.vue?vue&type=script&lang=ts"
export * from "./ListeAffectation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__